import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sportix_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sportix_token');
      localStorage.removeItem('sportix_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/update-profile', data),
  changePassword: (data) => api.put('/auth/change-password', data),
};

export const jobsAPI = {
  getJobs: (params) => api.get('/jobs', { params }),
  getJob: (id) => api.get(`/jobs/${id}`),
  createJob: (data) => api.post('/jobs', data),
  updateJob: (id, data) => api.put(`/jobs/${id}`, data),
  deleteJob: (id) => api.delete(`/jobs/${id}`),
  applyJob: (id, data) => api.post(`/jobs/${id}/apply`, data),
  getApplications: (id) => api.get(`/jobs/${id}/applications`),
  updateApplicationStatus: (appId, status) => api.put(`/jobs/applications/${appId}/status`, { status }),
  getMyJobs: () => api.get('/jobs/my/posted'),
  getMyApplications: () => api.get('/jobs/my/applications'),
};

export const servicesAPI = {
  getServices: (params) => api.get('/services', { params }),
  getService: (id) => api.get(`/services/${id}`),
  createService: (data) => api.post('/services', data),
  updateService: (id, data) => api.put(`/services/${id}`, data),
  orderService: (id, data) => api.post(`/services/${id}/order`, data),
  getMyServices: () => api.get('/services/my'),
};

export const profilesAPI = {
  getAll: (params) => api.get("/profiles", { params }),
  getProfiles: (params) => api.get('/profiles', { params }),
  getProfile: (uuid) => api.get(`/profiles/${uuid}`),
  getOrganizations: (params) => api.get('/profiles/organizations', { params }),
  addExperience: (data) => api.post('/profiles/experience', data),
  deleteExperience: (id) => api.delete(`/profiles/experience/${id}`),
  getSaved: () => api.get('/saved'),
  saveItem: (data) => api.post('/saved', data),
};

export const messagesAPI = {
  getConversations: () => api.get('/messages'),
  getMessages: (uuid) => api.get(`/messages/${uuid}`),
  sendMessage: (data) => api.post('/messages', data),
};

export const notificationsAPI = {
  getNotifications: () => api.get('/notifications'),
  markAllRead: () => api.put('/notifications/read-all'),
};

export const generalAPI = {
  getCategories: () => api.get('/sport-categories'),
  getJobRoles: () => api.get("/job-roles"),
  getRoles: () => api.get("/job-roles"),
  getStats: () => api.get('/stats'),
};

export const uploadAPI = {
  uploadAvatar: (file) => {
    const fd = new FormData(); fd.append('avatar', file);
    return api.post('/upload/avatar', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  uploadLogo: (file) => {
    const fd = new FormData(); fd.append('logo', file);
    return api.post('/upload/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  uploadResume: (file) => {
    const fd = new FormData(); fd.append('resume', file);
    return api.post('/upload/resume', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  uploadServiceCover: (file) => {
    const fd = new FormData(); fd.append('service_cover', file);
    return api.post('/upload/service-cover', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export default api;
